import { showUserAlert } from "../utils/userErrorMessage";
// src/pages/bugReport.jsx
import React, { useState } from "react";
import Header from "../Component/Header";
import { supabase } from "../supabase/client";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function BugReport() {
  const [form, setForm] = useState({ title: "", content: "" });
  const [saving, setSaving] = useState(false);

  const company = localStorage.getItem("email") || "";
  const companyName = localStorage.getItem("companyName") || company;

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const validate = () => {
    const title = (form.title || "").trim();
    const content = (form.content || "").trim();
    if (!company) {
      showUserAlert("회사(로그인 이메일) 정보를 찾을 수 없습니다. 다시 로그인해주세요.");
      return false;
    }
    if (!title) {
      showUserAlert("제목을 입력해주세요.");
      return false;
    }
    if (!content) {
      showUserAlert("내용을 입력해주세요.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (saving) return;
    if (!validate()) return;

    try {
      setSaving(true);
      const payload = {
        title: form.title.trim(),
        content: form.content.trim(),
        company, // 접속한 이메일 자동 저장
        company_name: companyName,
      };

      const { error } = await supabase.from("bug-report").insert(payload);
      if (error) {
        console.error("bug-report insert error:", error);
        showUserAlert("버그 신고 저장에 실패했습니다: " + (error.message || "알 수 없는 오류"));
        return;
      }

      showUserAlert("버그 신고가 등록되었습니다. 감사합니다!");
      setForm({ title: "", content: "" });
    } catch (e) {
      console.error(e);
      showUserAlert("버그 신고 처리 중 오류가 발생했습니다: " + (e.message || e));
    } finally {
      setSaving(false);
    }
  };

  const handleKeyDown = (e) => {
    // Ctrl/Cmd + Enter 로 제출
    if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="space-y-4">
      <Header />
      <div className="p-4 space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold">버그 신고</h2>
          <div className="text-sm text-gray-500">
            회사명: <b>{companyName || "미확인"}</b>
          </div>
        </div>

        <Card className="border-0 shadow-none">
          <CardContent className="bg-white space-y-4 p-4">
            <div>
              <label className="block font-semibold mb-1">제목</label>
              <Input
                placeholder="버그 제목을 입력해주세요"
                value={form.title}
                onChange={(e) => handleChange("title", e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">내용</label>
              <textarea
                className="w-full border border-gray-300 rounded px-3 py-2 h-56 text-sm"
                placeholder={`재현 방법(어떤 화면 → 어떤 버튼 → 어떤 메시지), 기대한 동작, 실제 결과, 스크린샷/콘솔 오류 내용 등을 자세히 적어주세요.`}
                value={form.content}
                onChange={(e) => handleChange("content", e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <div className="text-xs text-gray-500 text-right mt-1">
                {form.content.length.toLocaleString()}자
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <Button
                variant="outline"
                onClick={() => setForm({ title: "", content: "" })}
                disabled={saving}
              >
                초기화
              </Button>
              <Button onClick={handleSubmit} disabled={saving}>
                {saving ? "저장중..." : "제출"}
              </Button>
            </div>

            <div className="text-xs text-gray-500">
              * 단축키: <b>Ctrl(or Cmd) + Enter</b>로 제출할 수 있어요.
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
